import { StyleSheet } from 'aphrodite';

export const AppTheme = {
  primaryColor: '#3f51b5',
  primaryColorVariant: '#ef3e79',
  secondaryColor: '#ff4081',
  mainBg: 'white',
  secondaryBg: '#e4e4e4',//'#d2cece',
  pagePadding: 5,
  viewPort: 900
}


export const AppStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: AppTheme.mainBg,
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: AppTheme.mainBg,
  },
  entityTableLinkIcon: {
    padding: 3,
    fontSize: 28,
    color: 'black',
    cursor: 'pointer'
  },
  pageTitle: {
    fontSize: 32,
    paddingBottom: 24
  }
});



// WEBPACK FOOTER //
// ./src/styles/AppTheme.js